import React from 'react'
import { Button, ListGroup, ListGroupItem } from 'reactstrap'
import Fuse from 'fuse.js'
import { Field, reduxForm } from 'redux-form'
import FormattedMessage from '../../FormattedMessage/FormattedMessage'
import Loader from '../../Loader/Loader'
import SupportModal from '../../Modal/SupportModal/SupportModal'
import { renderField } from '../../../utilities/reduxForm.util'
import { required, emailValidator, dateRequired, alphaNumeric } from '../../../utilities/validators'

import './ProofOfPurchaseForm.scss'

const validate = values => {
  const errors = {}
  // DoP check before submitting form
  if (!values.popDateOfPurchase) {
    errors.popDateOfPurchase = 'global.label.requiredField'
  }

  if (!values.numberOfHardware || values.numberOfHardware === 1) {
    if (!values.popHardwareReceipt1 || values.popHardwareReceipt1 === '') {
      errors.popHardwareReceipt1 = 'global.label.requiredField'
    }
    if (!values.popHardwareType1 || values.popHardwareType1 === 'N/A') {
      errors.hardwareType1 = 'global.label.requiredField'
    }
  } else {
    for (let index = 1; index <= values.numberOfHardware; index++) {
      const hardwareType = values[`popHardwareType${index}`]
      const hardwareReceipt = values[`popHardwareReceipt${index}`]
      if (!hardwareType || hardwareType === 'N/A') {
        errors[`popHardwareType${index}`] = 'global.label.requiredField'
      }
      if (!hardwareReceipt || hardwareReceipt === '') {
        errors[`popHardwareReceipt${index}`] = 'global.label.requiredField'
      }
    }
  }

  return errors
}

class ProofOfPurchaseForm extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      modalOpen: false,
      error: false,
      submitting: false,
      processorsFiltered: [],
      hardwareType: ['CPU', 'GPU'],
      processorsResult: [],
      popHardwareReceipts: [{ popHardwareReceipt1: '', hardwareType1: '' }],
      count: 1,
      activeIndex: 1,
    }
  }

  fuseSearch = (processorsFiltered, popHardwareReceipt) => {
    const fuse = new Fuse(processorsFiltered, {
      keys: ['value'],
      includeScore: true,
    })
    const results = fuse.search(popHardwareReceipt).filter(result => result.score < 0.5)

    this.setState({
      processorsResult: results.length > 0 ? results.map(retailer => retailer.item) : [],
    })
  }

  onSearch = (e, index) => {
    const { currentTarget } = e
    const { change } = this.props
    const { hardwareType, processorsFiltered, activeIndex } = this.state

    if (activeIndex !== index + 1) {
      this.setState({ activeIndex: index + 1 })
    }

    // we update redux store
    change(`popHardwareReceipt${index + 1}`, currentTarget.value)
    this.setState(
      state => ({
        popHardwareReceipts: [
          ...state.popHardwareReceipts.slice(0, index),
          {
            [`hardwareType${index + 1}`]:
              state.popHardwareReceipts[index][`hardwareType${index + 1}`],
            [`popHardwareReceipt${index + 1}`]: currentTarget.value,
          },
          ...state.popHardwareReceipts.slice(index + 1),
        ],
      }),
      () => {
        const { popHardwareReceipts } = this.state

        if (currentTarget.value.length === 0) this.setState({ processorsResult: [] })

        if (
          hardwareType.includes(popHardwareReceipts[index][`hardwareType${index + 1}`]) &&
          currentTarget.value.length > 0
        ) {
          this.fuseSearch(processorsFiltered, currentTarget.value)
        }
      }
    )
  }

  selectProcessor = (processor, index) => {
    const { change } = this.props

    change(`popHardwareReceipt${index + 1}`, processor.value)
    this.setState(state => ({
      processorsResult: [],
      popHardwareReceipts: [
        ...state.popHardwareReceipts.slice(0, index),
        {
          [`hardwareType${index + 1}`]:
            state.popHardwareReceipts[index][`hardwareType${index + 1}`],
          [`popHardwareReceipt${index + 1}`]: processor.value,
        },
        ...state.popHardwareReceipts.slice(index + 1),
      ],
    }))
  }

  hardwareTypeOnChange = (e, index) => {
    const { change, processors } = this.props

    this.setState(state => ({
      processorsFiltered: processors.filter(
        processor => processor.processor_type === e.target.value
      ),
      popHardwareReceipts: [
        ...state.popHardwareReceipts.slice(0, index),
        {
          [`popHardwareReceipt${index + 1}`]: '',
          [`hardwareType${index + 1}`]: e.target.value,
        },
        ...state.popHardwareReceipts.slice(index + 1),
      ],
      processorsResult: [],
    }))

    change(`popHardwareReceipt${index + 1}`, '')
  }

  addReceipt = () => {
    const { popHardwareReceipts, count } = this.state
    const { change } = this.props

    // Create a new receipt object with a unique index
    const newReceipt = {
      [`popHardwareReceipt${count + 1}`]: '',
      [`hardwareType${count + 1}`]: '',
    }

    change(`popHardwareReceipt${count + 1}`, '')
    change('numberOfHardware', count + 1)

    // Update the state with the new receipt
    this.setState({
      popHardwareReceipts: [...popHardwareReceipts, newReceipt],
      count: count + 1,
    })
  }

  removeReceipt = () => {
    const { popHardwareReceipts, count } = this.state
    const { change } = this.props

    if (popHardwareReceipts.length === 1) {
      // If there's only one receipt, reset the count to 1
      this.setState({
        popHardwareReceipts: [{ popHardwareReceipt1: '', hardwareType1: '' }],
        count: 1,
      })
      change(`popHardwareType${count}`, '')
      change(`popHardwareReceipt${count}`, '')
      change('numberOfHardware', 1)
    } else {
      // Remove the last receipt and decrement the count
      const updatedReceipts = popHardwareReceipts.slice(0, -1)

      change(`popHardwareType${count}`, '')
      change(`popHardwareReceipt${count}`, '')
      change('numberOfHardware', count - 1)

      this.setState({
        popHardwareReceipts: updatedReceipts,
        count: count - 1,
      })
    }
  }

  submitMaster = values => {
    const { submitting } = this.state

    if (submitting) {
      return
    }

    const { onSubmit, reset } = this.props

    const newValues = !values.numberOfHardware ? { ...values, numberOfHardware: 1 } : values

    this.setState({ submitting: true })

    return onSubmit(newValues)
      .then(() => {
        this.setState({ error: false })
      })
      .catch(() => {
        this.setState({ error: true })
      })
      .finally(() => {
        this.setState(pastState => ({
          modalOpen: !pastState.modalOpen,
          submitting: false,
        }))
        reset()
      })
  }

  render() {
    const { handleSubmit } = this.props
    const {
      modalOpen,
      error,
      submitting,
      hardwareType,
      processorsResult,
      popHardwareReceipts,
      activeIndex,
    } = this.state

    return (
      <form
        onSubmit={handleSubmit(this.submitMaster.bind(this))}
        method="post"
        aria-labelledby="pop-form-title"
      >
        <div id="pop-form-title" className="sr-only">
          Proof of purchase form
        </div>
        <SupportModal
          isOpen={modalOpen}
          toggle={() =>
            this.setState(pastState => ({
              modalOpen: !pastState.modalOpen,
            }))
          }
          error={error}
        />

        <div>
          <div className="sr-only">Purchase verification form</div>
          <div className="row">
            <div className="col-md-8">
              <div className="row">
                <Field
                  component={renderField}
                  validate={[required]}
                  inputType="input"
                  type="text"
                  containerclass="col form-group"
                  name="popName"
                  aria-describedby="popName"
                  label="global.label.yourName"
                />
                <Field
                  component={renderField}
                  validate={[required, emailValidator]}
                  inputType="input"
                  type="text"
                  containerclass="col form-group"
                  name="popEmail"
                  aria-describedby="popEmail"
                  label="global.label.yourEmail"
                />
              </div>
              <div className="row">
                <Field
                  component={renderField}
                  validate={[dateRequired]}
                  inputType="date"
                  type="date"
                  containerclass="col form-group"
                  name="popDateOfPurchase"
                  aria-describedby="popDateOfPurchase"
                  label="page.supportPage.proofOfPurchase.purchaseDate"
                  isPop
                />
              </div>
              <div className="row">
                <Field
                  component={renderField}
                  validate={[alphaNumeric]}
                  inputType="input"
                  type="text"
                  containerclass="col form-group"
                  name="popPurchaseFromRetailer"
                  aria-describedby="popPurchaseFromRetailer"
                  label="page.supportPage.proofOfPurchase.purchaseRetailer"
                />
              </div>
              <div className="row">
                <Field
                  component={renderField}
                  validate={[alphaNumeric]}
                  inputType="input"
                  type="text"
                  containerclass="col form-group"
                  name="popCountryOfPurchase"
                  aria-describedby="popCountryOfPurchase"
                  label="page.supportPage.proofOfPurchase.purchaseCountry"
                />
              </div>
              <div className="relative">
                {popHardwareReceipts.map((hardwareReceiptRow, index) => (
                  <div
                    className={`row pt-2 ${`hardwareReceiptRow${index + 1}`}`}
                    key={`hardwareReceiptRow${index + 1}`}
                    role="group"
                    aria-labelledby={`hardware-group-${index + 1}`}
                  >
                    <div id={`hardware-group-${index + 1}`} className="sr-only">
                      Hardware item {index + 1}
                    </div>
                    <div className="col-12 col-md-5">
                      <Field
                        className="form-control"
                        component={renderField}
                        validate={[required]}
                        inputType="select"
                        name={`popHardwareType${index + 1}`}
                        id="global.label.hardwareType"
                        label="global.label.hardwareType"
                        options={hardwareType.map(option => ({ key: option, value: option }))}
                        placeholder="global.label.hardwareType"
                        onChange={e => this.hardwareTypeOnChange(e, index)}
                      />
                    </div>
                    <div className="col-12 col-md-7">
                      <Field
                        component={renderField}
                        validate={[required]}
                        inputType="input"
                        type="text"
                        name={`popHardwareReceipt${index + 1}`}
                        onChange={e => this.onSearch(e, index)}
                        placeholder="page.supportPage.proofOfPurchase.selectAnotherProduct"
                        label="page.supportPage.proofOfPurchase.purchaseHardware1"
                        aria-expanded={
                          `popHardwareReceipt${index + 1}`.length > 0 && activeIndex === index + 1
                        }
                        aria-haspopup="listbox"
                        role="combobox"
                        aria-autocomplete="list"
                      />
                      {`popHardwareReceipt${index + 1}`.length > 0 && activeIndex === index + 1 && (
                        <div
                          className="list-group-style"
                          role="listbox"
                          aria-label="Hardware suggestions"
                        >
                          <ListGroup>
                            {processorsResult.slice(0, 5).map(processor => (
                              <ListGroupItem
                                key={processor.id}
                                onClick={() => this.selectProcessor(processor, index)}
                                style={{ fontWeight: 'normal' }}
                                tag="button"
                                type="button"
                                action
                                role="option"
                                tabIndex={0}
                                onKeyDown={e => {
                                  if (e.key === 'Enter' || e.key === ' ') {
                                    e.preventDefault()
                                    this.selectProcessor(processor, index)
                                  }
                                }}
                                aria-selected={false}
                              >
                                {processor.value}
                              </ListGroupItem>
                            ))}
                          </ListGroup>
                        </div>
                      )}
                    </div>
                  </div>
                ))}
                <div className="row">
                  <div className="col d-flex justify-content-end mt-2">
                    <Button
                      className="mt-2 px-2 button-hardware"
                      outline
                      color="dark"
                      onClick={() => this.removeReceipt()}
                      block
                      type="button"
                      aria-label="Remove hardware item"
                    >
                      <p>
                        <FormattedMessage id="global.label.hardwareRemove" />
                      </p>
                    </Button>
                    <Button
                      className="mt-2 ml-2 px-2 button-hardware"
                      outline
                      color="dark"
                      onClick={() => this.addReceipt()}
                      block
                      type="button"
                      aria-label="Add hardware item"
                    >
                      <p>
                        <FormattedMessage id="global.label.hardwareAdd" />
                      </p>
                    </Button>
                  </div>
                </div>

                <div className="row">
                  <Field
                    component={renderField}
                    validate={[required, alphaNumeric]}
                    inputType="input"
                    type="text"
                    containerclass="col form-group"
                    name="popCouponCode"
                    aria-describedby="popCouponCode"
                    label="global.label.yourCouponCode"
                  />
                </div>
                <div className="row">
                  <Field
                    component={renderField}
                    inputType="textarea"
                    type="text"
                    containerclass="col"
                    name="popComments"
                    aria-describedby="popComments"
                    label="global.label.yourQuestion"
                  />
                </div>
              </div>
            </div>
            <div className="col-md-4">
              <Field
                component={renderField}
                inputType="fileupload"
                type="file"
                name="popSupportFiles"
                aria-describedby="popSupportFiles"
                containerclass="h-100"
              />
            </div>
          </div>
          <Button
            name="popFormSubmitBtn"
            type="submit"
            className="mt-5"
            outline
            color="dark"
            block
            disabled={submitting}
            aria-describedby="pop-form-title"
            aria-busy={submitting}
          >
            {submitting ? <Loader noBorder /> : <FormattedMessage id="global.label.verifyPhone" />}
          </Button>
        </div>
      </form>
    )
  }
}

export default reduxForm({
  form: 'ProofOfPurchaseForm',
  validate,
})(ProofOfPurchaseForm)
